import React from 'react';
import WHInvoiceFunctional from './components/wh-invoice-list-functional';
import './invoice.scss';

const WHInvoice = () => {
	return <WHInvoiceFunctional />;
};

export default WHInvoice;
